import {
  useTreeRef,
  useProjectTree,
  getOpenMap,
  useProjectUIActions,
} from "stores/project";
import useResizeObserver from "use-resize-observer";
import React, { useCallback } from "react";
import { Tree } from "@hogartrabe/react-arborist-vrh";
import { SummaryListItem } from "components/SummaryListItem";
import type { Node } from "interfaces/schemas";

export const VirtualizedProject = () => {
  const { toggleNode } = useProjectUIActions();
  const projectTree = useProjectTree();
  const treeRef = useTreeRef();
  const { ref, width } = useResizeObserver();
  const childrenAccessor = useCallback((d: Node) => d.nodes, []);

  return (
    <div ref={ref} className="overflow-x-hidden">
      <Tree
        data={projectTree ?? []}
        initialOpenState={getOpenMap() ?? undefined}
        childrenAccessor={childrenAccessor}
        indent={32}
        width={width}
        height={650}
        ref={treeRef}
        rowHeight={52}
        paddingBottom={32}
      >
        {({ node, style, ...props }) => (
          <SummaryListItem
            node={node}
            style={{
              ...style,
              paddingLeft: node.level * 12,
            }}
            toggleNode={toggleNode}
            {...props}
          />
        )}
      </Tree>
    </div>
  );
};
